module.exports = __webpack_public_path__ + "static/logo-47de7da6420d60445b8216d246339be7.png";